import { createRouter, createWebHistory } from "vue-router";
import Live from "@/views/Live.vue";
import Prematch from "@/views/Prematch.vue";
import Ticker from "@/views/Ticker.vue";
import Subs from "@/views/Subs.vue";
import About from "@/views/About.vue";
import Contact from "@/views/Contact.vue";
import Privacy from "@/views/Privacy.vue";
import Terms from "@/views/Terms.vue";
import Page404 from "@/views/Page404.vue";
import store from "@/store";
import { MatchUtil } from "@/store/utils";
import CookiesPage from "./views/CookiesPage.vue";
import TestRaise from "./views/TestRaise.vue";

const { MATCH_CATEGORIES } = MatchUtil;

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/live",
    },
    {
      path: `/${MATCH_CATEGORIES.LIVE}`,
      name: MATCH_CATEGORIES.LIVE,
      component: Live,
    },
    {
      path: `/${MATCH_CATEGORIES.PREMATCH}`,
      name: MATCH_CATEGORIES.PREMATCH,
      component: Prematch,
    },
    {
      path: `/${MATCH_CATEGORIES.TICKER}`,
      name: MATCH_CATEGORIES.TICKER,
      component: Ticker,
    },
    {
      path: "/subscriptions",
      name: "sub",
      component: Subs,
    },
    {
      path: "/about_us",
      name: "about_us",
      component: About,
    },
    {
      path: "/contact_us",
      name: "contact_us",
      component: Contact,
    },
    {
      path: "/privacy_policy",
      name: "privacy_policy",
      component: Privacy,
    },
    {
      path: "/terms_and_conditions",
      name: "terms_and_conditions",
      component: Terms,
    },
    {
      path: "/cookie_policy",
      name: "cookie_policy",
      component: CookiesPage,
    },
    {
      path: "/test_raise",
      name: "test_raise",
      component: TestRaise,
    },
    {
      path: "/:catchAll(.*)",
      name: "Page404",
      component: Page404,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  store.commit("SET_ROUTE", to);
  next();
});

export default router;
